

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';


export class ReferralSettlement {

    id?: any;
    billAmount: any;
    docSharePercent: any;
    docShareAMount: any;
    notes: string;
    createdDate: Date;
    updatedDate?: Date;
    approvedDatetime?: Date;
    createdBy: any;
    updatedBy?: any;
    billId: number;
    regId: any;
    status: string;
    physicianId?: any;
    accountManager?: any;
    tenantId: any;
    branchId: any;
    employee?:any;
    physicianMst?:any;
    regMst?:any;

  
  }
  export class ReferralSettlementConfig {

    id?: any;
   sharePercent: any;
    createdDate: Date;
    updatedDate?: Date;
    createdBy: any;
    updatedBy?: any;
    physicianId?: any;
    tenantId: any;
    serviceId?:any;
    service?:any;
    physicianMst?:any;

  
  }
  export abstract class ReferralSettlementData {
    abstract list(url: string): Observable<ReferralSettlement[]>;
    abstract configList(url: string): Observable<any[]>;
    abstract searchList(url: string, serachList: any): Observable<ReferralSettlement[]>;
    abstract referalTransList(url: string, serachList: any): Observable<any[]>;
    abstract create(url: string, data: ReferralSettlement[]): Observable<any>;
    abstract bulkCreate(url: string, data: any[]): Observable<any>;
    abstract update(url: string, data: any): Observable<any>;
  }